var _rect, _rect2, _path, _path2, _rect3, _rect4, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#E2001A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7619 19.6192H18.0952M28.7619 25.7144H18.0952M28.7619 13.5239H18.0952",
    stroke: "#E2001A",
    strokeWidth: 1.52381,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2842 13.5238C14.2842 13.657 14.2099 13.8539 14.0312 14.0327C13.8524 14.2115 13.6554 14.2857 13.5223 14.2857C13.3893 14.2857 13.1929 14.2116 13.0145 14.033C12.8362 13.8545 12.7619 13.6575 12.7619 13.5238C12.7619 13.3902 12.8362 13.1931 13.0145 13.0146C13.1929 12.836 13.3893 12.7619 13.5223 12.7619C13.6554 12.7619 13.8524 12.8362 14.0312 13.0149C14.2099 13.1937 14.2842 13.3907 14.2842 13.5238ZM14.2842 19.619C14.2842 19.7522 14.2099 19.9491 14.0312 20.1279C13.8524 20.3067 13.6554 20.381 13.5223 20.381C13.3893 20.381 13.1929 20.3068 13.0145 20.1283C12.8362 19.9497 12.7619 19.7527 12.7619 19.619C12.7619 19.4854 12.8362 19.2884 13.0145 19.1098C13.1929 18.9312 13.3893 18.8571 13.5223 18.8571C13.6554 18.8571 13.8524 18.9314 14.0312 19.1102C14.2099 19.289 14.2842 19.4859 14.2842 19.619ZM14.2842 25.7143C14.2842 25.8474 14.2099 26.0444 14.0312 26.2232C13.8524 26.4019 13.6554 26.4762 13.5223 26.4762C13.3893 26.4762 13.1929 26.4021 13.0145 26.2235C12.8362 26.045 12.7619 25.8479 12.7619 25.7143C12.7619 25.5806 12.8362 25.3836 13.0145 25.2051C13.1929 25.0265 13.3893 24.9524 13.5223 24.9524C13.6554 24.9524 13.8524 25.0266 14.0312 25.2054C14.2099 25.3842 14.2842 25.5811 14.2842 25.7143Z",
    fill: "#FFBAB1",
    stroke: "#E2001A",
    strokeWidth: 1.52381
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 22.5,
    width: 9,
    height: 9,
    rx: 4.5,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 22.5,
    width: 9,
    height: 9,
    rx: 4.5,
    stroke: "#E2001A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5834 27.4166H25.5C25.382 27.4166 25.283 27.3767 25.2032 27.2968C25.1233 27.2169 25.0834 27.118 25.0834 26.9999C25.0834 26.8819 25.1233 26.7829 25.2032 26.703C25.283 26.6232 25.382 26.5833 25.5 26.5833H27.5834V24.4999C27.5834 24.3819 27.6233 24.2829 27.7032 24.203C27.783 24.1232 27.882 24.0833 28 24.0833C28.1181 24.0833 28.2171 24.1232 28.2969 24.203C28.3768 24.2829 28.4167 24.3819 28.4167 24.4999V26.5833H30.5C30.6181 26.5833 30.7171 26.6232 30.7969 26.703C30.8768 26.7829 30.9167 26.8819 30.9167 26.9999C30.9167 27.118 30.8768 27.2169 30.7969 27.2968C30.7171 27.3767 30.6181 27.4166 30.5 27.4166H28.4167V29.4999C28.4167 29.618 28.3768 29.7169 28.2969 29.7968C28.2171 29.8767 28.1181 29.9166 28 29.9166C27.882 29.9166 27.783 29.8767 27.7032 29.7968C27.6233 29.7169 27.5834 29.618 27.5834 29.4999V27.4166Z",
    fill: "#E2001A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlist);
export default __webpack_public_path__ + "static/media/slist.4d3e39cf.svg";
export { ForwardRef as ReactComponent };